import { Admin, Resource } from "react-admin";
import simpleRestProvider from "ra-data-simple-rest";

import GroupsIcon from "@mui/icons-material/Groups";
import ShieldIcon from "@mui/icons-material/Shield";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import ArticleIcon from "@mui/icons-material/Article";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import EventNoteIcon from "@mui/icons-material/EventNote";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Person2Icon from "@mui/icons-material/Person2";

import { PlayerList, PlayerEdit, PlayerCreate } from "./players";
import { OpponentList, OpponentEdit, OpponentCreate } from "./opponents";
import { MatchList, MatchEdit, MatchCreate } from "./matches";
import { NewsList, NewsEdit, NewsCreate } from "./news";
import { ContactList, ContactShow } from "./contacts";
import { LeagueFixtureList, LeagueFixtureEdit, LeagueFixtureCreate } from "./leagueFixtures";
import { SeasonList, SeasonEdit, SeasonCreate } from "./seasons";
import { RosterList, RosterEdit, RosterCreate } from "./roster";

import { authProvider } from "./authProvider";
import { httpClient } from "./httpClient";

import Dashboard from "./Dashboard";
import CustomLayout from "./CustomLayout";
import CustomLoginPage from "./CustomLoginPage";
import { lightTheme, darkTheme } from "./theme";

const dataProvider = simpleRestProvider("/api", httpClient);

function App() {
  return (
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      dashboard={Dashboard}
      layout={CustomLayout}
      loginPage={CustomLoginPage}
      theme={lightTheme}
      darkTheme={darkTheme}
      title="Dinamo Ostia — Admin"
    >
      <Resource
        name="admin/seasons"
        list={SeasonList}
        edit={SeasonEdit}
        create={SeasonCreate}
        icon={CalendarMonthIcon}
        options={{ label: "Stagioni" }}
      />
      <Resource
        name="admin/matches"
        list={MatchList}
        edit={MatchEdit}
        create={MatchCreate}
        icon={SportsSoccerIcon}
        options={{ label: "Partite" }}
      />
      <Resource
        name="admin/league-fixtures"
        list={LeagueFixtureList}
        edit={LeagueFixtureEdit}
        create={LeagueFixtureCreate}
        icon={EventNoteIcon}
        options={{ label: "Calendario girone" }}
      />
      <Resource
        name="admin/roster"
        list={RosterList}
        edit={RosterEdit}
        create={RosterCreate}
        icon={Person2Icon}
        options={{ label: "Rosa" }}
      />
      <Resource
        name="admin/players"
        list={PlayerList}
        edit={PlayerEdit}
        create={PlayerCreate}
        icon={GroupsIcon}
        options={{ label: "Giocatori" }}
      />
      <Resource
        name="admin/opponents"
        list={OpponentList}
        edit={OpponentEdit}
        create={OpponentCreate}
        icon={ShieldIcon}
        options={{ label: "Avversari" }}
      />
      <Resource
        name="admin/news"
        list={NewsList}
        edit={NewsEdit}
        create={NewsCreate}
        icon={ArticleIcon}
        options={{ label: "News" }}
      />
      <Resource
        name="admin/contacts"
        list={ContactList}
        show={ContactShow}
        icon={MailOutlineIcon}
        options={{ label: "Contatti" }}
      />
    </Admin>
  );
}

export default App;
